import { useLocation, Navigate, Outlet } from 'react-router-dom'
import useAuthExtranet from '../../hooks/useAuthExtranet'

const RequireAuthExtranet = () => {
  const { auth } = useAuthExtranet()
  const location = useLocation()
  return auth?.accessToken ? (
    <Outlet />
  ) : (
    <Navigate to="/ext_login" state={{ from: location }} replace />
  )
}

export default RequireAuthExtranet
